module.exports = "<svg width=\"23\" height=\"23\" viewBox=\"0 0 23 23\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.5 23C5.15 23 0 17.85 0 11.5S5.15 0 11.5 0 23 5.15 23 11.5 17.85 23 11.5 23zm-1.725-9.085L7.36 11.5l-.805.805 3.22 3.22 6.9-6.9-.805-.805-6.095 6.095z\" fill-rule=\"nonzero\" fill=\"#FFF\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Icon/svg/selected_invert.svg
// module id = 825
// module chunks = 0